<div class="table-responsive">
    <table class="table table-sm table-hover table-bordered">
        <thead>
            <tr>
                <th class="text-center">{{'FullName' | translate}}</th>
                <th class="text-center">{{'Actions' | translate}}</th>
                <th class="text-center">{{'DateTime' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of startProjectLogs">
                <td class="text-center">{{item.fullName}}</td>
                <td class="text-center">{{tableAction[item.startProjectTableAction] | translate}}</td>
                <td class="text-center">{{item.dateTime | dateConverter:'DD/MM/yyyy HH:mm:ss'}}</td>
            </tr>
        </tbody>
    </table>
</div>